import React from 'react'
import Icon from 'components/shared/Icon'
import MuiTableRow from '@mui/material/TableRow'
import TealToolTip from 'components/TealToolTip'
import ParamTableCell from './ParamTableCell'
import TableCell from 'components/dealwatch/TableCell'
import url from 'libraries/front-end-core/core/url'
import { MW_DEAL_DETAILS } from 'constants/controllers'
import { useSelector } from 'react-redux'
import selectAolName from 'redux/selectors/selectAolName'

const TableRow = ({
  compareParams,
  deal,
  handleRemoveDeal,
  parameter,
  dealCount
}) => {
  const { dealId, title } = deal
  const aol = useSelector(selectAolName)

  return (
    <MuiTableRow hover>
      <TableCell
        cxNames='relative'
      >
        <div className='flex items-center'>
          <TealToolTip title={title || ''} placement='top'>
            <a
              className='max-w14 pr6 db truncate'
              href={url(MW_DEAL_DETAILS, { aol, dealId })}
              data-testid='deal-detail-link'
            >
              {title}
            </a>
          </TealToolTip>
          {/*
            TODO: suggested feature.. can delete if not required
            <ExpertCommentary {...{ expertCommentary }} />
          */}
        </div>
        {dealCount > 2 && (
          <div className='absolute top1 right2 o-30 hover-o-100'>
            <a
              href={null}
              className='pointer'
              onClick={handleRemoveDeal(dealId)}
            >
              <Icon className='w6' name='icon-close' />
            </a>
          </div>
        )}
      </TableCell>
      {compareParams.map(paramName => {
        const formatted = parameter(deal, paramName).formattedValue
        const keyName = paramName === null ? 'null' : paramName

        return (
          <ParamTableCell
            key={keyName}
            {...{ paramName, deal, formatted }}
          />
        )
      })}
    </MuiTableRow>
  )
}

export default TableRow
